export const urlParam=new URLSearchParams(window.location.search)
export const Token=urlParam.get('token')
export const gameId=urlParam.get('gameId')
export const isdemo=urlParam.get('isdemo')
export const drawId=urlParam.get('drawId')